/* Label & Leaf — v2-flow basket interactions.
   On Shopify: qty/remove go through /cart/change.js then reload.
   In the local harness (no /cart endpoints): update the DOM locally so
   states stay realistic for review. */
(function () {
  'use strict';

  var root = document.getElementById('llb');
  if (!root) return;

  var isShopify = /\/cart/.test(window.location.pathname);

  /* The shop sells in £ and in $; a hard-coded symbol turned a UK basket
     into dollars the moment a quantity changed. */
  function money(cents) {
    if (window.LLMoney && window.LLMoney.format) return window.LLMoney.format(cents);
    return (cents / 100).toFixed(2);
  }

  /* A write the shop refused (a 422 from /cart/change.js when the quantity
     is not available) used to reload the page anyway, so the row simply
     reverted with no explanation. */
  function fail(item, message) {
    var holder = item || root;
    var note = holder.querySelector('[data-llb-error]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'llb-item__blocked';
      note.setAttribute('data-llb-error', '');
      note.setAttribute('role', 'status');
      /* under the product name, where the eye already is — the row is a
         grid, so appending would drop the message into the next column */
      var name = holder.querySelector('.llb-item__name');
      if (name) name.insertAdjacentElement('afterend', note);
      else holder.appendChild(note);
    }
    note.textContent = message;
  }

  function parseMoney(text) {
    return Math.round(parseFloat(String(text).replace(/[^0-9.]/g, '')) * 100) || 0;
  }

  /* ---------- local summary recompute (harness + optimistic UI) ---------- */
  function recompute() {
    var items = root.querySelectorAll('[data-llb-item]');
    var subtotal = 0;
    var count = 0;
    items.forEach(function (item) {
      var unit = Number(item.getAttribute('data-unit-price')) ||
        parseMoney(item.querySelector('.llb-item__price').textContent);
      var qty = Number(item.querySelector('[data-llb-qty]').value);
      if (!item.getAttribute('data-unit-price')) {
        item.setAttribute('data-unit-price', String(unit / (qty || 1)));
      }
      var unitPrice = Number(item.getAttribute('data-unit-price'));
      var line = unitPrice * qty;
      item.querySelector('.llb-item__price').textContent = money(line);
      subtotal += line;
      count += qty;
    });
    var discount = root.__discount || 0;
    var total = Math.max(0, subtotal - discount);
    var q = function (s) { return root.querySelector(s); };
    if (q('[data-llb-count]')) q('[data-llb-count]').textContent = count + (count === 1 ? ' item' : ' items');
    if (q('[data-llb-subtotal]')) q('[data-llb-subtotal]').textContent = money(subtotal);
    root.querySelectorAll('[data-llb-total]').forEach(function (el) { el.textContent = money(total); });
    var drow = q('[data-llb-discount-row]');
    if (drow) {
      drow.hidden = discount === 0;
      if (discount > 0) q('[data-llb-discount]').textContent = '−' + money(discount);
    }
    if (count === 0) window.location.reload();
  }

  /* seed unit prices */
  root.querySelectorAll('[data-llb-item]').forEach(function (item) {
    var qty = Number(item.querySelector('[data-llb-qty]').value) || 1;
    var line = parseMoney(item.querySelector('.llb-item__price').textContent);
    item.setAttribute('data-unit-price', String(line / qty));
  });

  /* ---------- qty change ---------- */
  root.querySelectorAll('[data-llb-qty]').forEach(function (input) {
    input.setAttribute('data-llb-qty-was', input.value);
    input.addEventListener('change', function () {
      var item = input.closest('[data-llb-item]');
      var key = item.getAttribute('data-key');
      /* a digital Star Book and the lines of a chart bundle are one per order */
      var locked = item.getAttribute('data-digital-starbook') === 'true' || item.getAttribute('data-quantity-locked') === 'true';
      var wanted = locked ? 1 : Math.max(1, Math.floor(Number(input.value) || 1));
      input.value = String(wanted);
      var refuse = function () {
        input.value = input.getAttribute('data-llb-qty-was') || '1';
        fail(item, 'We couldn’t change that quantity. Please try again.');
        recompute();
      };
      if (isShopify) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: wanted })
        }).then(function (response) {
          if (!response.ok) { refuse(); return; }
          window.location.reload();
        }).catch(refuse);
      } else {
        input.setAttribute('data-llb-qty-was', input.value);
        recompute();
      }
    });
  });

  /* ---------- remove ---------- */
  root.querySelectorAll('[data-llb-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-llb-item]');
      var key = item.getAttribute('data-key');
      var refuse = function () {
        fail(item, 'We couldn’t remove that item. Please try again.');
      };
      if (isShopify) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function (response) {
          if (!response.ok) { refuse(); return; }
          window.location.reload();
        }).catch(refuse);
      } else {
        item.remove();
        recompute();
      }
    });
  });

  /* ---------- voucher ---------- */
  /* The field used to recognise one demo code, subtract £10 from the
     displayed total and report "Applied ✓" — a total no order would ever
     honour. Shopify applies codes at /discount/<code>, which validates the
     code and carries it into checkout, so that is where the field now
     sends it. */
  var applyBtn = root.querySelector('[data-llb-voucher-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var input = root.querySelector('[data-llb-voucher-input]');
      var code = (input.value || '').trim();
      if (!code) return;
      if (isShopify) {
        window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout');
      } else {
        /* local harness: no /discount route to follow */
        applyBtn.textContent = 'At checkout';
        setTimeout(function () { applyBtn.textContent = 'Apply'; }, 2400);
      }
    });
  }

  /* ---------- preview lightbox ---------- */
  var lightbox = root.querySelector('[data-llb-lightbox]');
  if (lightbox) {
    var mockup = lightbox.querySelector('[data-llb-lightbox-mockup]');
    var scene = lightbox.querySelector('[data-llb-lightbox-scene]');
    var artwork = lightbox.querySelector('[data-llb-lightbox-img]');
    var previewTitle = lightbox.querySelector('[data-llb-lightbox-title]');
    var previewNote = lightbox.querySelector('[data-llb-lightbox-note]');
    var closeButton = lightbox.querySelector('.llb-lightbox__close');
    var openingButton = null;
    var previousBodyOverflow = '';

    var notebookBinding = function (value) {
      return /wiro|spiral/i.test(value || '') ? 'wiro' : 'hardcover';
    };

    root.querySelectorAll('[data-llb-preview]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var title = btn.getAttribute('data-title') || 'Personalised design';
        var rawBinding = btn.getAttribute('data-binding') || '';
        var isNotebook = btn.getAttribute('data-product-kind') === 'notebook' || rawBinding !== '';
        var binding = notebookBinding(rawBinding);
        var bindingLabel = binding === 'wiro' ? 'Wiro' : 'Hardcover';

        mockup.className = 'llb-lightbox__mockup llb-lightbox__mockup--' + (isNotebook ? binding : 'artwork');
        scene.src = isNotebook
          ? scene.getAttribute(binding === 'wiro' ? 'data-wiro-src' : 'data-hardcover-src')
          : '';
        artwork.src = btn.getAttribute('data-src');
        artwork.alt = isNotebook
          ? title + ' — personalised ' + bindingLabel + ' notebook preview'
          : title + ' — personalised artwork preview';
        previewTitle.textContent = title;
        previewNote.textContent = isNotebook
          ? 'Shown as a finished ' + bindingLabel.toLowerCase() + ' notebook.'
          : 'Your personalised artwork preview.';

        openingButton = btn;
        btn.setAttribute('aria-expanded', 'true');
        lightbox.hidden = false;
        previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(function () { closeButton.focus(); });
      });
    });
    var closeLightbox = function () {
      if (lightbox.hidden) return;
      lightbox.hidden = true;
      document.body.style.overflow = previousBodyOverflow;
      if (openingButton) {
        openingButton.setAttribute('aria-expanded', 'false');
        openingButton.focus();
        openingButton = null;
      }
    };
    lightbox.querySelectorAll('[data-llb-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });
    /* any click that isn't on the artwork panel itself closes the preview */
    lightbox.addEventListener('click', function (e) {
      if (!e.target.closest('.llb-lightbox__panel')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
      if (e.key === 'Tab' && !lightbox.hidden) {
        e.preventDefault();
        closeButton.focus();
      }
    });
  }

  /* ---------- extras add ---------- */
  root.querySelectorAll('[data-lla-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      var done = function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          if (isShopify) window.location.reload();
          else btn.textContent = 'Add';
        }, 900);
      };
      var refuse = function () {
        btn.textContent = 'Not added';
        setTimeout(function () { btn.textContent = 'Add'; }, 2400);
      };
      if (variantId && isShopify) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        }).then(function (response) {
          if (!response.ok) { refuse(); return; }
          done();
        }).catch(refuse);
      } else {
        done();
      }
    });
  });

  /* ---------- lines this market cannot ship ----------
     Moved to assets/ll-cart-guard.js: the basket page is not the only place
     a customer sees their lines — Dawn's drawer opens on every other page
     and offered an unguarded Checkout of its own. One guard now runs on
     both, loaded from layout/theme.liquid. */
})();
